import React from 'react';
import { Autocomplete, Box } from '@mui/material';
import { PinnacleTextField } from '../../../../../components/PinnacleTextField';
import { School } from '../../../../../api/interfaces/School';
import { Examinee, PartialEditExamineeFormRequest } from '../../../../../api/interfaces/preboard/Examinee';

interface ExamineeInformationProps {
    schools: School[];
    formData: PartialEditExamineeFormRequest;
    onChange: (field: string, value: any) => void;
    onSuccess: (updatedUser: Examinee, skipClose?: boolean) => void;
    selectedUserInfo?: Examinee;
    disabled?: boolean;
    setIsSubmitting: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserInformation: React.FC<ExamineeInformationProps> = ({
    formData,
    onChange,
    schools,
    disabled
}) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <PinnacleTextField
                label="Suffix"
                name="suffix"
                value={formData.suffix}
                onChange={(e) => onChange("suffix", e.target.value)}
                fullWidth
                disabled={disabled}
            />

            <PinnacleTextField
                label="Birthdate"
                name="birthDate"
                type="date"
                value={formData.birthDate
                    ? formData.birthDate.split("T")[0]
                    : ""}
                onChange={(e) => onChange("birthDate", e.target.value)}
                fullWidth
                disabled={disabled}
            />

            <Autocomplete
                options={schools}
                getOptionLabel={(option: School) => option.name}
                value={schools.find((s) => s.name === formData.school) || null}
                onChange={(_, newValue) => onChange("school", newValue ? newValue.name : "")}
                renderInput={(params) => (
                    <PinnacleTextField
                        {...params}
                        label="School"
                        fullWidth
                        disabled={disabled}
                    />
                )}
            />
        </Box>
    );
};


export default UserInformation;
